import React, { useEffect, useRef, useState } from "react";
import { Table, Spinner } from "react-bootstrap";
import { baseUrl } from "../../../../services/config";
import { useAlert } from "react-alert";
import Pagination from "@material-ui/lab/Pagination";
import usePagination from "../../../../components/usePagination/usePagination";
import Select from "react-select";
function GetAllSchoolInvoice({ getcurrentsession, getStudentArray }) {
  const authtoken = localStorage.getItem("userToken");
  const [dataloader, setdataloader] = useState(false);
  const [allsessions, setallsessions] = useState([]);
  const alert = useAlert();
  const [currentsession, setcurrentsession] = useState("");
  const banksloaded = useRef(false);
  const searchClicked = useRef(false);
  const [selectedSchools, setSelectedSchools] = useState([]);
  const [mainCheckBoxChecked, setMainCheckboxChecked] = useState(false);
  const [schoolAccountData, setSchoolAccountData] = useState([]);
  const [regionsData, setRegionsData] = useState([]);
  const [regionId, setRegionId] = useState(null);

  useEffect(() => {
    getAllSessions();
    getRegions();
  }, []);

  useEffect(() => {
    // getAllCampus();
    if (!banksloaded.current) {
      banksloaded.current = true;
      getAllSessions();
      getRegions();
    }

    // selectedChallansArray = [...selectedChallans];
    if (searchClicked.current) {
      setAllCheckboxes(true);
      searchClicked.current = false;
    } else {
      checkAllCheckBoxes();
    }
  }, [[], selectedSchools]);

  const getAllSessions = () => {
    fetch(`${baseUrl}/session`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setallsessions(data.payload);
        data.payload.map((item, index) => {
          if (item.active_financial_year == "1") {
            setcurrentsession(item.id.toString());
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getSchoolAccounts = async () => {
    setdataloader(true);
    await fetch(
      `${baseUrl}/school-accounts/region${regionId ? `/${regionId}` : ""}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${authtoken}`,
        },
      }
    )
      .then((res) => {
        res.json().then((data) => {
          if (!data.metadata.success) {
            alert.error(data.metadata.message);
            setdataloader(false);
            return;
          } else {
            setSchoolAccountData(data.payload);
            setdataloader(false);
            searchClicked.current = true;
          }
        });
      })
      .catch((err) => {
        alert.error(err);
        setdataloader(false);
      });
  };

  const getRegions = async () => {
    await fetch(`${baseUrl}/regions`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          let arr = [{ label: "Select Region", value: null }];
          data.payload.forEach((element) => {
            arr.push({
              label: element.name,
              value: element.id,
            });
          });
          setRegionsData(arr);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  // Checkbox Logic
  const handleMainCheckboxClick = () => {
    if (mainCheckBoxChecked) setAllCheckboxes(false);
    else setAllCheckboxes(true);
  };

  const setAllCheckboxes = (value) => {
    setMainCheckboxChecked(value);
    if (value) {
      setSelectedSchools([]);
    }

    schoolAccountData.map((item, i) => {
      item.checked = value;
      if (!value) {
        RemoveSelectedSchool(item);
      } else {
        AddSelectedSchool(item);
      }
    });
  };

  const checkAllCheckBoxes = () => {
    if (schoolAccountData.length == selectedSchools.length) {
      setMainCheckboxChecked(true);
    } else if (mainCheckBoxChecked) {
      setMainCheckboxChecked(false);
    }
  };

  const handleSchoolsCheckBoxClick = (e, index) => {
    schoolAccountData.map((item, i) => {
      if (item.id == index) {
        item.checked = !item.checked;

        if (item.checked) {
          AddSelectedSchool(item);
        } else {
          RemoveSelectedSchool(item);
        }
      }
    });
  };

  const AddSelectedSchool = (item) => {
    setSelectedSchools((prevSelectedChallans) => [
      ...prevSelectedChallans,
      item.id,
    ]);
  };

  const RemoveSelectedSchool = (item) => {
    setSelectedSchools((prevSelectedChallans) =>
      prevSelectedChallans.filter((id) => id !== item.id)
    );
  };

  useEffect(() => {
    getStudentArray(selectedSchools);
  }, [selectedSchools, getStudentArray]);

  const changesession = (id) => {
    setcurrentsession(id);
    getcurrentsession(id);
  };

  let [page, setPage] = useState(1);
  const PER_PAGE = 10;

  const count = Math.ceil(schoolAccountData.length / PER_PAGE);
  const _DATA = usePagination(schoolAccountData, PER_PAGE);

  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };

  return (
    <div>
      <div class="form-group row">
        <div className="col-md-3">
          <label className="form-control-label">
            <b>
              Select Session <span style={{ color: "red" }}>*</span>
            </b>
          </label>
          <select
            onChange={(e) => changesession(e.target.value)}
            class="form-select"
            style={{ height: 40 }}
            value={currentsession}
            aria-label="Default select example"
            disabled
          >
            <option value="">Select Session</option>
            {allsessions.map((session) => (
              <option value={session.id}>{session.year}</option>
            ))}
          </select>
        </div>

        <div className="col-md-5">
          <label className="form-control-label">
            <b>
              Select Region <span style={{ color: "red" }}>*</span>{" "}
            </b>
          </label>
          <Select
            onChange={(e) => setRegionId(e.value)}
            placeholder="Select Region"
            options={regionsData}
          />
        </div>

        {/* <div className="col-md-3">
          <label>
            <b>Select Campus </b> <span style={{ color: "red" }}>*</span>
          </label>
          <select
            onChange={(e) => onchangecampus(e.target.value)}
            className="form-select"
            style={{ height: 40 }}
            value={campusid}
            aria-label="Default select example"
          >
            <option selected value="">
              Select Campus
            </option>

            {campuses.map((campus) => (
              <option key={campus.id} value={campus.id}>
                {campus.name}
              </option>
            ))}
          </select>
        </div>

        <div className="col-md-3">
          <label>
            <b>Select Class </b> <span style={{ color: "red" }}>*</span>
          </label>
          <select
            onChange={(e) => onchangeclassfunc(e.target.value)}
            className="form-select"
            style={{ height: 40 }}
            aria-label="Default select example"
          >
            <option selected value="">
              Select Class
            </option>

            {classes.map((item) => (
              <option name={item.name} key={item.id} value={item.id}>
                {item.name}
              </option>
            ))}
          </select>
        </div>

        <div className="col-md-3">
          <label>
            <b>Select Education Type</b>
          </label>
          <select
            className="form-select"
            name="campus_id"
            value={educationType}
            style={{ height: 40 }}
            aria-label="Default select example"
            onChange={(e) => {
              setEducationType(e.target.value);
              getSectionsListOnTypeChange(e.target.value);
            }}
          >
            <option selected value={0}>
              All Education Type
            </option>
            <option value={1}>Education</option>
            <option value={2}>Hifz</option>
          </select>
        </div>

        <div className="col-md-3 mt-3">
          <label>
            <b>Select Section </b> <span style={{ color: "red" }}>*</span>
          </label>
          <select
            onChange={(e) => {
              setsectionid(e.target.value);
            }}
            class="form-select"
            style={{ height: 40 }}
            aria-label="Default select example"
          >
            <option selected value="">
              Select Section
            </option>
            {sections.map((clas) => (
              <option value={clas.id}>{clas.name}</option>
            ))}
          </select>
        </div> */}

        <div className="col-md-4 mt-7">
          <button className="btn btn-primary" onClick={getSchoolAccounts}>
            Show School Account
          </button>
        </div>

        {/* <div className="col-md-8">
          <form className="row mt-9" onSubmit={searchbyRegId}>
            <div className="col-md-8">
              <input
                onChange={(e) => setsearchtext(e.target.value)}
                className="form-control"
                placeholder="Enter Name or Admission ID"
              />
            </div>
            <div className="col-md-4">
              <button type="submit" className="btn btn-primary">
                Search Student
              </button>
            </div>
          </form>
        </div> */}
      </div>

      <Table responsive>
        <thead>
          <tr className="text-center">
            <th>
              <label className="checkbox checkbox-single">
                <input
                  type="checkbox"
                  className="form-checkbox"
                  checked={mainCheckBoxChecked}
                  onClick={(e) => {
                    handleMainCheckboxClick();
                  }}
                />
                <span />
              </label>
            </th>
            <th>School Name</th>
            <th>Region Name</th>
            <th>Contact Person</th>
            <th>Contact No.</th>
            <th>Estimated Monthly Royalty</th>
          </tr>
        </thead>
        <tbody>
          {_DATA.currentData().map((school, index) => (
            <tr key={school?.id} className="text-center">
              <td>
                <label className="checkbox checkbox-single">
                  <input
                    type="checkbox"
                    className="form-checkbox"
                    value={school.id}
                    key={school.id}
                    onClick={(e) => {
                      handleSchoolsCheckBoxClick(e, school.id);
                    }}
                    checked={school.checked ?? false}
                  />
                  <span />
                </label>
              </td>
              <td>{school?.school_name}</td>
              <td>{school?.region?.name}</td>
              <td>{school?.contact_person ?? "---"}</td>
              <td>{school?.contact_number ?? "---"}</td>
              <td>
                {Intl.NumberFormat("en-Us").format(
                  school?.estimated_monthly_royalty
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Pagination
        color="text-primary"
        count={count}
        size="large"
        page={page}
        variant="text"
        shape="rounded"
        onChange={handleChange}
      />

      <div className="row justify-content-center">
        {dataloader && (
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        )}
      </div>
    </div>
  );
}

export default GetAllSchoolInvoice;
